module.exports = __webpack_public_path__ + "media/images/icons/share-df6e4ceda9c6c077e223d4b4ec395c14.svg";